import * as httpProtocol from './httpProtocol';
import { logError } from '../../utils/httpClientUtil';
import { getAppConfig } from '../../services/init/appConfig';
const option = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: httpProtocol.AuthenticationTypes.Spza
};
export function getUserAuthStatus() {
    const isEmbed = getAppConfig('embedded');
    if (!isEmbed) {
        const endpoint = '/view/signinStatus';
        const get = httpProtocol.get(endpoint, option);
        return get.addQueryEntry('version', getAppConfig('apiVersion')).request().then((result)=>{
            return result;
        }).catch((error)=>{
            logError('getSigninStatus', error);
            return Promise.resolve(null);
        });
    }
}
